;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.partnerLookup = (function () {
    const ARC_WKID = 4326
    // const info = document.getElementById('info')
    const FIND_ADDRESS_URL = 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates'
    const QUERY_URL = 'https://arcgis.atlantaregional.com/arcgis/rest/services/OpenData/FeatureServer/198/query'

    function setupListeners () {
      $('#partnerLookupForm').on('submit', handleSubmit)
    }

    function handleSubmit (evt) {
      evt.preventDefault()
      // console.log('submitted')
      const address = $('.addressInput').val()
      // console.log('Address', address)
      geoCode(address)
    }

    function geoCode (address) {
      $.getJSON(FIND_ADDRESS_URL, {
        SingleLine: address,
        f: 'json',
        outSR: { wkid: ARC_WKID },
        // magicKey: 'dHA9MCNsb2M9ODY2OTEzI2xuZz0zMyNobj0yOTI0I2xicz0xMDk6Mzc2OTI4MDE=',
        maxLocations: 6
      }, processGeoCodeResult)
    }

    function processGeoCodeResult (data) {
      // console.log('result', data)

      if (data && data.candidates && data.candidates.length) {
        const candidate = data.candidates[ 0 ]
        const coordinates = candidate.location
        // console.log('coordinates', coordinates)
        query(coordinates)
      }
    }

    function query (coordinates) {
      const params = {
        where: '1=1',
        outFields: 'NAME,Contact,Email,Phone', // '*' if you want to see all
        geometry: coordinates.x + ',' + coordinates.y,
        geometryType: 'esriGeometryPoint',
        inSR: ARC_WKID,
        spatialRel: 'esriSpatialRelWithin',
        outSR: ARC_WKID,
        f: 'json'
      }
      $.getJSON(QUERY_URL, params, processQueryResult)
    }

    function processQueryResult (data) {
      const $options = $('.partner-block__options')
      // console.log('result', data)
      const feature = (data && data.features && data.features.length > 0) ? data.features[ 0 ] : {}
      const attrs = feature && feature.attributes && feature.attributes
      const partnerName = (attrs && attrs.NAME) ? attrs.NAME : 'NO-MATCH'
      // console.log('partnerName', partnerName, attrs)
      const $partnerBlock = $options.find(`.partner-block[data-name="${partnerName}"]`)
      if ($partnerBlock && attrs) {
        const email = `<a href="mailto:${attrs.Email}">${attrs.Email}</a>`
        $options.find('.partner-block').addClass('d-none')
        $partnerBlock.find('.partner__name span').text(attrs.Contact)
        $partnerBlock.find('.partner__email span').html(email)
        $partnerBlock.find('.partner__phone span').text(attrs.Phone)
        $partnerBlock.removeClass('d-none')
      } else {
        $options.find('.partner-block').addClass('d-none')
        $options.find(`.partner-block[data-name="${partnerName}"]`).removeClass('d-none')
      }
    }

    function init () {
      // kick off here
      setupListeners()
    }

    return {
      init: init
    }
  }())

  $(document).ready(function () {
    GCO.partnerLookup.init()
  })
}(jQuery, window))
